import { B2cUser, B2cUsersResult } from '../../../integrated-client/models/';
import { ApiUserPermissionsGetUsersGetRequest } from '../../../integrated-client/apis/UserPermissionsApi';

export class ResultsData {

  users?: Array<B2cUser> | null;
  skipToken?: string | null;
  pages: Array<B2cUsersResult>;
  currentPage: number;
  query?: ApiUserPermissionsGetUsersGetRequest;

  constructor() {
    this.users = null;
    this.skipToken = null;
    this.pages = [];
    this.currentPage = 1;
  }

}
